import { useOnline } from '@vueuse/core';
import { $MTS, ContentType, DateFormatter, message, RequestMethod } from '@mts-fe/utils';
import { getRequestHeaders } from './auth';
import { globSetting, IN_DEV } from './env';
import { deviceInfo, SERVICE_PREFIX } from '.';

/** 开发日志埋点 */
export function logInfo(content: string, extra = {}, { remote = false } = {}) {
  const info = getBaseLogInfo(extra);
  localStorage.getItem('debug') == '2' && message.open({ content, duration: 10 });
  $MTS.log(content, JSON.stringify(info));

  if (!remote) return;
  return logSave(content, info);
}

/** 开发错误埋点 */
export function logError(content: string, extra = {}) {
  console.error(content, extra);
  const info = getBaseLogInfo(extra);
  localStorage.getItem('debug') == '2' && message.open({ content, duration: 10 });
  $MTS.log(content, JSON.stringify(info));

  // return logSave(content, info);
}

/** 获取基本的埋点信息 */
export const getBaseLogInfo = (extra = {}) => ({
  timestamp: DateFormatter.DTS(new Date()),
  deviceId: deviceInfo.deviceId,
  url: location.hash,
  ...extra,
});

const saveLogUrl = globSetting.apiUrl + SERVICE_PREFIX.ILOG + '/api/warning/logs/save';
const logSave = (address: string, message: object) => {
  !IN_DEV &&
    useOnline().value &&
    fetch(saveLogUrl, {
      method: RequestMethod.POST,
      headers: { 'Content-Type': ContentType.JSON, ...getRequestHeaders() },
      body: JSON.stringify({
        address,
        message: JSON.stringify(message),
        type: 3,
        deviceId: deviceInfo.deviceId,
        timeStamp: Date.now(),
      }),
    });
};
